/* ==========================================================================
   DIIP CART DRAWER — บังคับ Login ก่อนกด Checkout
   ถ้ายังไม่ Login (data-requires-login="true" ที่ตัวปุ่ม ตั้งค่าจาก Liquid
   ตอน Render หน้าเว็บ) จะดัก Click ไว้ก่อน แล้ว Redirect ไปหน้าที่กำหนดไว้
   แทนการเข้า Checkout จริง — ถ้า Login แล้วปล่อยให้ Submit ไป Checkout ปกติ
   ========================================================================== */

document.addEventListener(
  'click',
  function (e) {
    var btn = e.target.closest('#CartDrawer-Checkout');
    if (!btn) return;

    if (btn.getAttribute('data-requires-login') === 'true') {
      e.preventDefault();
      e.stopPropagation();

      var redirectUrl = btn.getAttribute('data-guest-redirect-url');
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
    // ถ้า data-requires-login ไม่ใช่ "true" (Login แล้ว) ปล่อยผ่านไปตามปกติ
    // ให้ Submit Form เข้า Checkout จริงต่อไปได้เลย ไม่ต้องทำอะไรเพิ่ม
  },
  true // ใช้ Capture Phase ดักให้ทันก่อน Logic Submit Form อื่นๆ ของธีมจะทำงาน
);
